<template>
  <div>
    <Form  class="signForm" > 
            <h3>
                {{$t('verifyStep5')}}
            </h3>
            <h4>
                {{$t('complete1')}}
            </h4>
            <p >
                {{$t('complete21')}} <router-link style="color:#e32b3a" to="/uploadPhoto">{{$t('complete22')}}</router-link> {{$t('complete23')}}
            </p>
            <!-- <h4>
                {{$t('complete3')}}
            </h4>
             <p >
                {{$t('complete4')}}
            </p> -->
             <p >
                {{$t('complete5')}}
            </p>
             <!-- <h4 class="lasth4">
                {{$t('complete6')}}
            </h4> -->
            <FormItem class="itemBtns">
                <Button type="primary" class="formBtn" style="font-size:20px"  @click="upload">{{$t('uploadComplete')}}</Button>
                <Button type="primary" class="formBtn" style="font-size:20px"  @click="close">{{$t('close')}}</Button>
            </FormItem>
    </Form>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'



export default {
  name: 'Home',
  data(){
    return{
        checked:false
    }
    
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    created(){
    },
    methods:{
        
        upload(){
            this.$router.push({ path:'/uploadPhoto'})
            // this.$emit('changeSteps',3)
        },
        close(){
            this.$store.commit('logout')
            this.$router.push({ path:'/login'})
        }
    }
}
</script>
<style lang="less">
.verify{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    
    .signForm{
        h3{
            display: block;
            width: 100%;
            position: relative;
            margin-bottom: 20px;
            padding-left: 20px;
            font-size: 18px;
            color: #332c2b;
            font-weight: normal;
        }
        h3::before{
            content: "";
            position: absolute;
            left: 0px;
            top: 50%;
            width: 8px;
            height: 8px;
            background-color: #e32b3a;
            border-radius: 4px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
        }
        h4{
            font-size: 18px;
            color: #332c2b;
        }
        p{
            margin-bottom: 20px;
            color: #332c2b;
        }
        .lasth4{
            margin-bottom: 20px;
        }
    }
}
</style>
